import React from 'react';
import clsx from 'clsx';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import { Bar } from 'react-chartjs-2';
import InputLabel from '@material-ui/core/InputLabel';
import ChartJSImage from 'chart.js-image';
import SaveIcon from '@material-ui/icons/Save';
import ReactToPdf from 'react-to-pdf';
import { makeStyles } from '@material-ui/styles';
import PDF from './PDF';
import {
    IconButton,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Select,
    MenuItem,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors
} from '@material-ui/core';
import { get_overview_report, get_showrooms } from '../../api/API';
import moment from 'moment/moment.js'
import DatePicker from 'react-date-picker';
import "./overview.css";
import { max } from 'date-fns';
import { CSVLink } from "react-csv";



const useStyles = makeStyles(theme => ({
    root: {
        padding: '24px',
    },

}));

export default class BarChart extends React.Component {


    constructor(props) {
        super(props);
        this.colors = ["#faf13e", "#b8fa3e", "#3efa9f", "#21decb", "#3c8ae8", "#8438e0", "#e038cc", "#f0328b", "#eb2f4e"];

        this.ref = React.createRef();
        var start_date = new Date();
        start_date.setDate(start_date.getDate() - 7);
        this.state = {
            csv_output: [],
            start_print: false,
            redraw: false,
            grand_total: 0,
            raw_data: [],
            agencies_output: [],
            chart_option: {
                maintainAspectRatio: false,
                devicePixelRatio: 20,
                scales: {
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            min: 0,
                            max: 10,
                            stepSize: 1
                        }
                    }]
                }
            },
            chartData: {},
            showrooms: [],
            values: {
                showroom: "",
                metric: "appointments",
                date_from: moment().subtract(7, 'day').format("yyyy-MM-DD"),
                date_to: moment().format("yyyy-MM-DD"),
                appointment_type: "all"
            }
        };
        this.get_data();
        this.get_showroom_data();
    }


    handleChange(e) {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
        }, () => {
            this.get_data();
        });

    }

    async get_showroom_data() {
        var currentObj = this;
        let showrooms = await get_showrooms();
        if (showrooms) {
            currentObj.setState({
                ...this.state,
                showrooms: showrooms
            });
        }
    }

    parse_chart_data(data) {
        var labels = [];
        var datasets = [];
        var total = 0;
        var agency_dataset = {

        };
        var max_y_tick = 2;
        for (var i = 0; i < data.length; i++) {
            labels.push(data[i].short_name == "" ? data[i].name : data[i].short_name);
            for (var j = 0; j < data[i].agencies.length; j++) {
                var agency = data[i].agencies[j];
                if (agency_dataset['a_' + agency.agency_id] == undefined) {
                    agency_dataset['a_' + agency.agency_id] = {
                        values: {}
                    };
                }
                agency_dataset['a_' + agency.agency_id].name = (agency.name);
                agency_dataset['a_' + agency.agency_id].values['p_' + data[i].property_id] = agency.total;
                agency_dataset['a_' + agency.agency_id].color = agency.color;

                total += agency.total;

                max_y_tick = max_y_tick > parseInt(agency.total) ? max_y_tick : parseInt(agency.total);
            }
        }


        var index = 0;
        for (var key in agency_dataset) {
            var row_data = [];
            var row = agency_dataset[key];
            for (var i = 0; i < data.length; i++) {
                var value = row.values['p_' + data[i].property_id] ? row.values['p_' + data[i].property_id] : 0;
                row_data.push(value);


            }
            datasets.push({
                label: row.name,
                backgroundColor: row.color,
                borderColor: row.color,
                borderWidth: 1,
                hoverBackgroundColor: row.color,
                hoverBorderColor: row.color,
                data: row_data
            });
            index++;
        };


        this.setState({
            ...this.state,
            chartData: {
                labels: labels,
                datasets: datasets
            },
            chart_option: {
                scales: {
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            min: 0,
                            max: (max_y_tick + 5),
                            stepSize: 1
                        }
                    }]
                }
            }
        });
    }

    async print() {

    }
    async get_data() {
        console.log(this.state.values);
        var values = {
            ...this.state.values,
            date_from: moment(this.state.values.date_from).format("yyyy-MM-DD"),
            date_to: moment(this.state.values.date_to).format("yyyy-MM-DD")
        }
        var data = await get_overview_report(values);
        if (data) {
            this.setState({
                ...this.state,
                raw_data: data.data
            });
            this.parse_chart_data(data.data);
            this.parse_table_data(data.data, data.agencies)
        }
    }

    parse_table_data(data, agencies) {
        var data_output = [];
        var grand_total = 0;
        for (var agencies_i = 0; agencies_i < agencies.length; agencies_i++) {
            var agency_row = agencies[agencies_i];
            var temp_row = [(agency_row.name)];
            var row_total = 0;
            var cell_val = 'N/A';
            for (var data_i = 0; data_i < data.length; data_i++) {
                var data_row = data[data_i];
                for (var data_agency_i = 0; data_agency_i < data_row['agencies'].length; data_agency_i++) {
                    if (data_row.agencies[data_agency_i].agency_id == agency_row.agency_id) {
                        row_total += parseInt(data_row.agencies[data_agency_i].total);
                        grand_total += parseInt(data_row.agencies[data_agency_i].total);
                        cell_val = data_row.agencies[data_agency_i].total;
                        break;
                    }
                }
                temp_row.push(cell_val);
            }
            temp_row.push(row_total);
            data_output.push(temp_row);
        }

        this.setState({
            ...this.state,
            agencies_output: data_output,
            grand_total: grand_total
        }, this.downloadCSV);
    }

    downloadCSV() {
        var export_data = [];
        var header = [''];
        this.state.raw_data.map((row) => {
            header.push(row.name);
        });
        header.push('Total');
        export_data.push(header);

        this.state.agencies_output.map(row => {
            var data_row = [];
            row.map((cell) => {
                data_row.push(cell);
            });
            export_data.push(data_row);
        });
        this.setState({
            ...this.state,
            csv_output: export_data
        }, () => {
            console.log(this.state)
        }
        );

    }

    render() {
        return (
            <React.Fragment>
                <Header
                    classes={this.props.classes}
                    onSidebarOpen={this.props.handleSidebarOpen}
                />
                <Sidebar
                    classes={this.props.classes}
                    onClose={this.props.handleSidebarClose}
                    open={this.props.shouldOpenSidebar}
                    variant={this.props.isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={this.props.classes.content}>
                    <div className={this.props.classes.toolbar} />
                    <br></br>

                    <div
                        {...this.props}
                        className={clsx(this.props.classes.root, this.props.className)}
                        style={{
                            height: "auto",
                            padding: 8
                        }}
                    >
                        <Card>
                            <CardHeader
                                action={
                                    <>
                                        <ReactToPdf
                                            targetRef={this.ref}
                                            filename={"Property_Overview_" + this.state.values.date_from + "_" + this.state.values.date_to + ".pdf"}
                                            scale={1}
                                            x={2}
                                            y={0}
                                            onComplete={(() => {
                                                this.setState({
                                                    ...this.state,
                                                    start_print: false,
                                                    redraw: true
                                                })
                                            }).bind(this)}
                                        >
                                            {({ toPdf }) => (
                                                <IconButton
                                                    onClick={(() => {
                                                        this.setState({
                                                            ...this.state,
                                                            start_print: true,
                                                            redraw: true
                                                        }, () => {
                                                            setTimeout(() => {

                                                                toPdf();
                                                            }, 2000);
                                                        });

                                                    }).bind(this)}
                                                >
                                                    <SaveIcon style={{ color: "black" }} />
                                                </IconButton>
                                            )}
                                        </ReactToPdf>
                                        <IconButton

                                        >
                                            <CSVLink
                                                data={this.state.csv_output}
                                                filename={"Property_Overview_" + this.state.values.date_from + "_" + this.state.values.date_to + ".csv"}
                                            >
                                                <img style={{
                                                    width: 26
                                                }} src={require("../../assets/excel_icon.png")}></img>
                                            </CSVLink>
                                        </IconButton>
                                    </>
                                }
                                title="Property Overview"
                            />
                            <Divider />
                            <CardContent className={useStyles.content}>
                                <div
                                    className="report_filter overview_filter"
                                >
                                    <div className="filter_field_wrapper">

                                        <InputLabel shrink id="metric_label">
                                            View
                                        </InputLabel>

                                        <Select
                                            className="full_width"
                                            labelId="metric_label"
                                            label="metric"
                                            onChange={this.handleChange.bind(this)}
                                            name="metric"
                                            value={this.state.values.metric}
                                        >
                                            <MenuItem
                                                value="appointments">
                                                Appointments
                                            </MenuItem>
                                            <MenuItem
                                                value="pax">
                                                Guests
                                            </MenuItem>
                                        </Select>
                                    </div>
                                    <div className="filter_field_wrapper">

                                        <InputLabel shrink id="metric_label">
                                            Guest Type
                                        </InputLabel>

                                        <Select
                                            className="full_width"
                                            labelId="appointment_type"
                                            label="appointment_type"
                                            onChange={this.handleChange.bind(this)}
                                            name="appointment_type"
                                            value={this.state.values.appointment_type}
                                        >
                                            <MenuItem
                                                value="all">
                                                All
                                            </MenuItem>
                                            <MenuItem
                                                value="1">
                                                New Prospect
                                            </MenuItem>
                                            <MenuItem
                                                value="2">
                                                Prospect Revisit
                                            </MenuItem>
                                            <MenuItem
                                                value="3">
                                                Buyer Revisits
                                            </MenuItem>
                                        </Select>
                                    </div>
                                    <div className="filter_field_wrapper">
                                        <InputLabel shrink id="property_label">
                                            Property
                                        </InputLabel>
                                        <Select
                                            labelId="property_label"
                                            onChange={this.handleChange.bind(this)}
                                            name="showroom"
                                            className="full_width"
                                            value={this.state.values.showroom}
                                        >
                                            <MenuItem
                                                value="">

                                            </MenuItem>
                                            <MenuItem
                                                value="all">
                                                All
                                            </MenuItem>
                                            {
                                                this.state.showrooms.map((showroom) => (
                                                    <MenuItem key={showroom.property_id}
                                                        value={showroom.property_id}>
                                                        {showroom.name}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </div>

                                    <div className="filter_field_wrapper">
                                        <TextField
                                            className="full_width"
                                            type="date"
                                            name="date_from"
                                            label="From"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_from}

                                        />
                                    </div>
                                    <div className="filter_field_wrapper">

                                        <TextField
                                            className="full_width"
                                            type="date"
                                            name="date_to"
                                            label="to"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_to}

                                        />
                                    </div>


                                    {/* <DatePicker
                                        format="dd/MM/y"
                                        onChange={date => this.setState({
                                            ...this.state,
                                            values: {
                                                ...this.state.values,
                                                date_from: date
                                            }
                                        }, () => {
                                            this.get_data();
                                        })}
                                        value={this.state.values.date_from}
                                        className="datepicker"
                                    ></DatePicker>
                                    <DatePicker
                                        format="dd/MM/y"
                                        onChange={date => this.setState({
                                            ...this.state,
                                            values: {
                                                ...this.state.values,
                                                date_to: date
                                            }
                                        }, () => {
                                            this.get_data();
                                        })}
                                        value={this.state.values.date_to}
                                        className="datepicker"
                                    ></DatePicker> */}

                                </div>
                                <div
                                    style={{
                                        width: this.state.start_print ? 700 : "auto"
                                    }}
                                    ref={this.ref}>
                                    {this.state.start_print && (
                                        <div style={{
                                            marginBottom: 30
                                        }}>
                                            <Grid container>
                                                <Grid item md={3}>
                                                    <img src={require("../../assets/logo_small.png")}></img>
                                                    <p>Showing date: {this.state.values.date_from} to {this.state.values.date_to}</p></Grid>
                                                <Grid item md={6} style={{
                                                    textAlign: 'center'
                                                }}>
                                                    <h1>Property Overview</h1>
                                                </Grid>
                                            </Grid>

                                        </div>
                                    )}

                                    <div style={{
                                        height: '60vh',
                                        maxHeight: '30vh',
                                    }}>
                                        <Bar

                                            redraw={this.state.redraw}
                                            width={this.state.start_print ? 700 : "auto"}
                                            height={this.state.start_print ? 200 : "auto"}

                                            data={this.state.chartData} options={{
                                                ...this.state.chart_option,
                                                devicePixelRatio: 4,
                                                maintainAspectRatio: false
                                            }}></Bar>
                                    </div>
                                    <div style={{
                                        width: "100%",
                                        marginTop: 30,
                                    }}>
                                        <Table className="report_table">
                                            <TableHead>
                                                <TableRow >
                                                    <TableCell style={{
                                                        textAlign: "center",
                                                        backgroundColor: "black",
                                                        color: "white"
                                                    }}
                                                        colSpan={this.state.raw_data.length + 2}>Appointments</TableCell>

                                                </TableRow>
                                                <TableRow>
                                                    <TableCell></TableCell>
                                                    {this.state.raw_data.map((row) => (
                                                        <TableCell>{row.name}</TableCell>
                                                    ))}
                                                    <TableCell
                                                        className="bold section_2"
                                                    >Total</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>

                                                {this.state.agencies_output.map((row) => (
                                                    <TableRow>
                                                        {row.map((val) => (
                                                            <TableCell className="bold">{val}</TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                                <TableRow>
                                                    <TableCell style={{ fontWeight: 'bold' }} colSpan={this.state.raw_data.length + 1}>
                                                        Total
                                                    </TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>{this.state.grand_total}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </div>
                                </div>

                            </CardContent>
                        </Card>
                    </div>
                </main >
            </React.Fragment >
        )
    }
}
